export const generateAutocompleteId = (field: string) =>
	[(process.env?.REACT_APP_FRONT_URL || '').split('//').pop(), field].join('__');
